import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\SendElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SendElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/send-to-yousign'
*/
const SendElectronicSignatureToYouSign = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendElectronicSignatureToYouSign.url(args, options),
    method: 'post',
})

SendElectronicSignatureToYouSign.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/{electronicSignature}/send-to-yousign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\SendElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SendElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/send-to-yousign'
*/
SendElectronicSignatureToYouSign.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return SendElectronicSignatureToYouSign.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\SendElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SendElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/send-to-yousign'
*/
SendElectronicSignatureToYouSign.post = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendElectronicSignatureToYouSign.url(args, options),
    method: 'post',
})

export default SendElectronicSignatureToYouSign